// The status palette from src/styles/tokens.css, in JS form.
//
// Why this file exists: a CSS custom property can only be resolved by the CSS
// engine. Colors that end up on a <canvas> (mapbox marker glyphs, echarts /
// google-charts series) or inside a third-party option object never reach the
// CSS engine, so `var(--status-run)` would render as an invalid color there.
// Those call sites import STATUS_COLORS instead.
//
// CONSTRAINT: these values MUST stay byte-identical to the --status-* tokens in
// src/styles/tokens.css. One meaning, one shade — Map markers, the Map legend
// and StationInfoDisplay's badges all read the same four constants, so a shade
// can no longer drift between the three surfaces that show the same status.
export const STATUS_COLORS = {
  run: '#22c55e', // --status-run   · water on / currently running
  fault: '#e5484d', // --status-fault · hardware issue, not configured, rain hold
  warn: '#f59e0b', // --status-warn  · manual override, off plan, degraded
  info: '#3b82f6', // --status-info  · configured & scheduled, idle-but-ready
};

export default STATUS_COLORS;
